import React from 'react';
import { withSnackbar } from 'notistack';
import { NavLink, withRouter } from 'react-router-dom';

import { ROUTE_CONSTANTS } from '../../../shared/constants/Route';
import MessageModal from '../../../components/molecules/MessageModal/index';
import { ScreenTitle, ProgressBar } from '../../../components/atoms';
import LoadingModal from '../../../components/atoms/LoadingModal';

import './style.scss';
import { checkOffline } from '../../../shared/services/Utility';
import { OFFLINE_USER } from '../../../shared/constants/Constants';

class FlashCardsScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      totalCards: 0,
      viewedCards: 0,
      hiddenCards: 0,
      count: 0,
      showModal: false,
    };
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //     if (nextProps !== prevState) {
  //
  //         return {
  //             loading: nextProps.loading,
  //         };
  //     }
  //     return null;
  // }

  componentDidUpdate(prevProps, prevState) {
    // this.setState({loading:true})

    if (
      this.props.FlashCardReducer.flashCardDetailList !==
      prevProps.FlashCardReducer.flashCardDetailList
    ) {

      let viewedCount = 0,
        hiddenCount = 0;
      if (this.props.FlashCardReducer) {
        let flashCardArray = this.props.FlashCardReducer.flashCardDetailList;
        flashCardArray.forEach((flashCard) => {
          /* special case */

          if (flashCard.isViewed === true) {
            flashCard.isViewed = '1';
          }
          if (flashCard.isViewed === false) {
            flashCard.isViewed = '0';
          }
          if (flashCard.isHidden === true) {
            flashCard.isHidden = '1';
          }
          if (flashCard.isHidden === false) {
            flashCard.isHidden = '0';
          }

          /* end special case */

          if (parseInt(flashCard.isViewed) && !parseInt(flashCard.isHidden)) {
            viewedCount++;
          }
          if (parseInt(flashCard.isHidden)) {
            hiddenCount++;
          }
        });
      }
      this.setState({
        viewedCards: viewedCount,
      });

      this.setState({
        hiddenCards: hiddenCount,
      });

      this.submitFlashcardUpdatedStatus(
        this.props.FlashCardReducer.flashCardDetailList,
      );
    }
  }

  submitFlashcardUpdatedStatus = (flashcardList) => {
    const flashCardDetails = {
      userId: this.props.userId,
      sessionToken: this.props.sessionToken,
      flashCardArray: flashcardList,
    };

    this.props.submitFlashCardDetails(flashCardDetails, (message, type) => {
      this.props.enqueueSnackbar(message, {
        variant: type,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    });
  };

  componentDidMount() {
    this.fetchFlashCardCount();
    this.fetchListOfCards();
    //this.props.state.CommonReducer.internetAlert=0
  }

  fetchListOfCards = () => {
    const flashcardDetails = {
      userId: this.props.userId,
      sessionToken: this.props.sessionToken,
    };
    this.props.getListOfFlashCards(flashcardDetails, (message, type) => {
      this.props.enqueueSnackbar(message, {
        variant: type,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    });
  };

  /*fetch total number of cards*/
  fetchFlashCardCount() {
    const flashcardDetails = {
      userId: this.props.userId,
      sessionToken: this.props.sessionToken,
    };

    this.props.getTotalFlashcards(
      flashcardDetails,
      (count) => {
        this.setState({
          count: count,
        });
      },
      (message, type) => {
        this.props.enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      },
      true,
    );
  }

  //   onStartBtn() {
  //     if (
  //       Number(this.props.state["CommonReducer"].totalCards) ===
  //       Number(this.state.hiddenCards)
  //     ) {
  //       Alert.alert(APP_NAME, TextConstants.ALL_CARDS_HIDDEN_MESSAGE);
  //     } else if (
  //       parseInt(this.state.hiddenCards) >= 25 &&
  //       this.props.state.CommonReducer.purchaseStatus == false
  //     ) {
  //       this.hidePurchaseGameModal(false);
  //     } else {
  //       if (this.blockedAccessToEnter === false) {
  //         this.blockedAccessToEnter = true;
  //         this.props.displayFlashcardScreen().then(() => {
  //           setTimeout(() => {
  //             this.blockedAccessToEnter = false;
  //           }, 200);
  //         });
  //       }
  //     }
  //   }

  onResetBtn = () => {
    if (!checkOffline()) {
      let flashCardArray = [];
      flashCardArray = this.props.state.FlashCardReducer.flashCardDetailList;
      flashCardArray.forEach((el) => {
        el.isHidden = false;
      });
      this.props.resetFlashCards(flashCardArray);

      this.submitFlashcardUpdatedStatus(flashCardArray);
      this.props.flashCardIndex(0);
      this.setState({
        hiddenCards: 0,
      });
      //this.state.hiddenCards =0;
    } else {
      this.props.enqueueSnackbar(OFFLINE_USER, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    }
  };

  render() {
    return (
      <>
        <ScreenTitle title={'Key Terms Flashcards'}/>

        {this.state.showModal && (
          <MessageModal
            // icon="trophy.png"
            title='Pre2pass'
            message={'All cards are hidden. Please reset to view cards.'}
            color={'#fff'}
            callback={() =>
              this.setState({ showModal: false })
            }
          />
        )}
        {this.props.loading ? (
          <LoadingModal isVisible={this.props.loading}/>
        ) : (
          <div className='card-summary-container'>
            <div className='row'>
              <div className='col6' key={'1'}>
                <div className='card-summary'>
                  <div className='icon-container'>
                    <img
                      src={require('../../../Assets/Images/Icons/flashcard.svg')}
                      alt=''
                      width='70'
                    />
                  </div>
                  <div className='summary'>
                    <h6>{'Total Flashcards'}</h6>
                    <p className='mt-1'>Total number of flashcards</p>
                  </div>
                  <div className='count'>
                    <span>{this.state.count}</span>
                  </div>
                </div>
              </div>

              <div className='col6' key={'2'}>
                <div className='card-summary'>
                  <div className='icon-container'>
                    <img
                      src={require('../../../Assets/Images/Icons/card_viewed.svg')}
                      alt=''
                      width='70'
                    />
                  </div>
                  <div className='summary'>
                    <h6>{'Cards Viewed'}</h6>
                    <span>Total number of cards viewed</span>
                    {/* <Progress completed={75} /> */}
                    <div className='mt-1'>
                      <ProgressBar
                        key={'11'}
                        completed={(this.state.viewedCards / 697) * 100}
                      />
                    </div>
                  </div>
                  <div className='count'>
                    <span>{this.state.viewedCards}</span>
                  </div>
                </div>
              </div>

              <div className='col6' key={'3'}>
                <div className='card-summary'>
                  <div className='icon-container'>
                    <img
                      src={require('../../../Assets/Images/Icons/card_hidden.svg')}
                      alt=''
                      width='70'
                    />
                  </div>
                  <div className='summary'>
                    <h6 style={{ fontWeight: 'bold' }}>{'Cards Hidden'}</h6>
                    <span>Total number of cards not viewed yet</span>
                    {/* <Progress completed={75} /> */}
                    <div className='mt-1'>
                      <ProgressBar
                        key={'22'}
                        completed={(this.state.hiddenCards / 697) * 100}
                      />
                    </div>
                  </div>
                  <div className='count'>
                    <span>{this.state.hiddenCards}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex btns card_btns'>
              <NavLink
                to='/'
                onClick={() => {
                  this.onResetBtn();
                }}
                className='blue-btn'
              >
                <img
                  src={require('../../../Assets/Images/Icons/reset_card.png')}
                  alt=''
                  className='btn-icon'
                />
                Reset Hidden Cards{' '}
              </NavLink>
              <button
                //to="/display-flashcards"
                onClick={() => {
                  if ((this.state.hiddenCards / 697) === 1) {
                    this.setState({
                      showModal: true,
                    });
                  } else {
                    this.props.history.push(`${ROUTE_CONSTANTS.DISPLAY_FLASH}`);
                  }
                }
                }


                className='start-cards-btn'
              >
                <img
                  src={require('../../../Assets/Images/Icons/start_card.png')}
                  alt=''
                  className='btn-icon'
                />
                Start Cards
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(withSnackbar(FlashCardsScreen));
